/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { delayedResponse } from '../companies/companiesMock';
import { makeMockResponse } from '../mockUtils';
import {
    ProductItemAiCategories,
    DocumentResource,
    DocumentsListDto,
    UnknownDocumentContent,
} from './documentsClient.typings';
import {
    aiCategoriesFactory,
    correctionDocumentResource,
    creditPayDocumentResource,
    depositDocumentResource,
    documentListItemDtoFactory,
    documentsGeneralInfoFactory,
    itemsFactory,
    moneyBackDocumentResource,
    openShiftDocumentResource,
    prepayDocumentResource,
    rollBackDocumentResource,
    saleDocumentResource,
    withdrawDocumentResource,
    zReportDocumentResource,
} from './documentsFactories';

const DOCUMENTS_LIST_URL = /\/1.0.0\/documents$/;
const DOCUMENT_CARD_DETAILS_URL: RegExp = /\/documents\/(\w+)\/card/;
const DOCUMENT_ITEMS_AI_CATEGORIES_URL: RegExp = /\/documents\/(\w+)\/aiCategories/;

export function addDocumentsMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onPost(DOCUMENTS_LIST_URL).reply((config) => {
        const body = JSON.parse(config.data);
        const data: DocumentsListDto = {
            afterKeyCreatedAtUtc: '2019-11-10T01:01:00.000Z',
            afterKeyId: '1431',
            documents: documentListItemDtoFactory.list({ count: body.limit === 10000 ? 4 : body.limit }),
        };
        return delayedResponse(makeMockResponse(200, data, config), 300);
    });

    mockAdapter.onGet(DOCUMENT_CARD_DETAILS_URL).reply((config) => {
        const docType = 'zReport';

        const getContentByDocType = (docType: string): UnknownDocumentContent => {
            itemsFactory.resetCount();
            switch (docType) {
                case 'sale':
                    return saleDocumentResource.item();

                case 'deposit':
                    return depositDocumentResource.item();

                case 'openShift':
                    return openShiftDocumentResource.item();

                case 'zReport':
                    return zReportDocumentResource.item();

                case 'withdraw':
                    return withdrawDocumentResource.item();

                case 'moneyBack':
                    return moneyBackDocumentResource.item();

                case 'rollBack':
                    return rollBackDocumentResource.item();

                case 'correction':
                    return correctionDocumentResource.item();

                case 'prepay':
                    return prepayDocumentResource.item();

                case 'creditPay':
                    return creditPayDocumentResource.item();
            }

            return saleDocumentResource.item();
        };

        const data: DocumentResource = {
            ...documentsGeneralInfoFactory.item(),
            content: getContentByDocType(docType),
        };

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });

    mockAdapter.onGet(DOCUMENT_ITEMS_AI_CATEGORIES_URL).reply((config) => {
        const data: ProductItemAiCategories[] = aiCategoriesFactory.list({ count: 9 });
        aiCategoriesFactory.resetCount();

        return delayedResponse(makeMockResponse(200, data, config), 5000);
    });
}
